// =============================================
// src/firebase/config.js
// =============================================
// 🔥 Firebase Console se copy karo:
// Firebase Console → ⚙️ Project Settings → General → 
// Your apps → Web app → Firebase SDK snippet

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCx-vh0NwmgMCXquZqiRGkHrVcovFT6JRE",
  authDomain: "sdtech-portal.firebaseapp.com",
  projectId: "sdtech-portal",
  storageBucket: "sdtech-portal.firebasestorage.app",
  messagingSenderId: "595652527302",
  appId: "1:595652527302:web:f4b4f28d430751b5e7c3c7",
  measurementId: "G-PP0YN2RLLM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase Services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;